import { render, staticRenderFns } from "./settingTabshop.vue?vue&type=template&id=ce650590"
import script from "./settingTabshop.vue?vue&type=script&lang=js"
export * from "./settingTabshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports